<template>
    <div
        class="card"
        :class="[
            {
                'card-title-box': title !== ''
            }
        ]"
    >
        <div
            v-if="$slots.header || header"
            class="card-header"
        >
            <slot name="header">
                {{ header }}
            </slot>
        </div>
        <div
            v-if="title"
            class="card-title"
        >
            <h2>
                {{ title }}
            </h2>
            <router-link
                v-if="moreLink !== ''"
                class="more"
                :to="moreLink"
            >
                <span v-if="!showMore">
                    更多
                </span>

            </router-link>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
        <div
            class="card-footer"
            v-if="$slots.footer || footer"
        >
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Card',
        props: {
            header: {},
            title: {
                type: String,
                default: ''
            },
            showMore: {
                type:Boolean,
                default: false
            },
            moreLink: {
                type: String,
                default: ''
            },
            footer: {},
        }

    };
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/mixins/_mixins';

    .card {
        width: 100%;
        margin-bottom: 10px;
        background-color: #fff;
        @include clearfix;

        &.card-title-box {
            padding-top: 30px;
        }

        &-title {
            height: 40px;
            margin-bottom: 26px;
            padding-left: 30px;
            border-left: 10px solid rgba(207, 0, 31, 1);
            line-height: 40px;

            h2 {
                float: left;
                font-size: 32px;
                font-weight: 600;
                line-height: 40px;
            }

            .more {
                position: relative;
                float: right;
                margin-right: 40px;
                padding-right: 10px;
                font-size: 24px;
                color: #999;

                &::after {
                    display: block;
                    position: absolute;
                    right: 0;
                    top: 17px;
                    width: 3px;
                    height: 3px;
                    content: '';
                    border-top: 4px solid transparent;
                    border-left: 5px solid #999;
                    border-bottom: 4px solid transparent;
                }
            }
        }
    }
</style>
